module.exports = __webpack_public_path__ + "media/ding.bc7c50bd.mp3";